import I18n from 'I18n';
import { useContext, useEffect, useState } from 'react';
import { TranscriptSearchNavigationButtons } from './TranscriptSearchNavigationButtons';
import { TranscriptContext } from '../../contexts/TranscriptContext';
import { PARTIAL } from '../../types/SearchTypes';
import { Flex } from 'foundations-components/components/Flex';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { Box } from 'foundations-components/transitional/components/Box';
import { useDebouncedCallback } from '../../hooks/useDebouncedCallback';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SEARCH_DEBOUNCE_MS = 250;
export const TranscriptSearchBar = () => {
  const {
    handleSelectResult,
    handleSearch,
    searchState,
    setAutoScrollTranscript,
    autoScrollTranscript
  } = useContext(TranscriptContext);

  // Local state for the input value so typing stays responsive.
  // The expensive search computation only runs after the debounce fires
  // and updates searchState in the context.
  const [inputValue, setInputValue] = useState(searchState.term);
  const debouncedSearch = useDebouncedCallback(term => {
    handleSelectResult(0);
    handleSearch({
      term,
      searchType: PARTIAL
    });
  }, SEARCH_DEBOUNCE_MS);

  // Cancel pending debounce on unmount
  useEffect(() => () => debouncedSearch.cancel(), [debouncedSearch]);

  // Clear local input and cancel any pending debounce when auto-scroll
  // is on and the context search term is empty. This covers both the
  // normal clear path (auto-scroll button after debounce fired) and the
  // race where the button is clicked before the debounce commits.
  useEffect(() => {
    if (autoScrollTranscript && searchState.term === '') {
      setInputValue('');
      debouncedSearch.cancel();
    }
  }, [autoScrollTranscript, searchState.term, debouncedSearch]);
  const handleChange = ({
    currentTarget: {
      value
    }
  }) => {
    setInputValue(value);
    setAutoScrollTranscript(value.length === 0);
    if (value.length === 0) {
      // No reason to debounce a clear since the search computation
      // short-circuits when the term is empty.
      debouncedSearch.cancel();
      handleSelectResult(0);
      handleSearch({
        term: '',
        searchType: PARTIAL
      });
    } else {
      debouncedSearch(value);
    }
  };
  return /*#__PURE__*/_jsxs(Flex, {
    justifyContent: "space-between",
    alignItems: "center",
    gap: "200",
    children: [/*#__PURE__*/_jsx(SearchInput, {
      "data-test-id": "searchBar",
      placeholder: I18n.text('recordingReviewComponents.transcript.searchBarPlaceholder'),
      onChange: handleChange,
      value: inputValue
    }), searchState.term && /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(TranscriptSearchNavigationButtons, {})
    })]
  });
};